import type { UserInfoResponse } from "../web-client/auth/data-contracts";
import * as operations from "../web-client/auth/operations";
import type { Transport } from "../web-client/transport";

export const accountKeys = {
  userInfo: () => ["accounts", "user-info"] as const,
};

export function getUserInfo(transport: Transport): Promise<UserInfoResponse> {
  return operations.getUserinfo(transport);
}

export function updateAccount(
  transport: Transport,
  { accountId, fullName, email }: { accountId: string; fullName: string; email?: string },
): Promise<void> {
  return operations.patchAccounts(transport, { accountId, body: { name: fullName, email } });
}

export function setPushNotificationToken(
  transport: Transport,
  { accountId, deviceToken, friendlyName }: { accountId: string; deviceToken: string; friendlyName: string },
): Promise<void> {
  return operations.putAccountsPushnotificationdevices(transport, {
    accountId,
    body: { enabled: true, surface: "web", deviceToken, friendlyName },
  });
}
